import { ComponentType } from 'react';
import { KnowledgeBaseActionBox } from '../KnowledgeBaseAction/KnowledgeBaseActionBox';
import { ActionDto, AIActionUsageStatsDto } from '@/Domain/api/Action/dto/Action.dto';
import { AiActionListEmpty } from '@/Domain/components/Action/AiActionList/AiActionList.empty';
import { ApiActionBox } from '@/Domain/components/Action/ApiAction/ApiActionBox';
import { RemoteMcpActionBox } from '@/Domain/components/Action/RemoteMCPAction/RemoteMcpActionBox';
import { ShopifyMcpActionBox } from '@/Domain/components/Action/ShopifyMcpAction/ShopifyMcpActionBox';
import { ActionTypeEnum } from '@/Domain/enum/ActionType.enum';

type ActionComp = ComponentType<{ action: ActionDto; stats?: AIActionUsageStatsDto }>;

const Config = {
  [ActionTypeEnum.HttpRequest]: ApiActionBox,
  [ActionTypeEnum.ShopifyRemoteMcp]: ShopifyMcpActionBox,
  [ActionTypeEnum.RemoteMcp]: RemoteMcpActionBox,
  [ActionTypeEnum.KnowledgeBase]: KnowledgeBaseActionBox,
  [ActionTypeEnum.Custom]: null,
} satisfies Record<ActionTypeEnum, ActionComp | null>;

type Props = {
  actions: ActionDto[];
  stats?: Record<string, AIActionUsageStatsDto>;
};

export const AiActionList: React.FC<Props> = ({ actions, stats }) => {
  const nodes = actions
    .map((action) => {
      const Component = Config[action.type];
      return Component ? (
        <Component key={action.id} action={action} stats={stats?.[String(action.id)]} />
      ) : null;
    })
    .filter(Boolean) as React.ReactElement[];

  if (nodes.length === 0) return <AiActionListEmpty actions={actions || []} />;
  return (
    <div
      className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 items-stretch"
      data-testid="ai-actions-list"
    >
      {nodes}
    </div>
  );
};
